import { Button, Card, Div, Text } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Faqs from './Faqs'

import BannerFooterImg from 'assets/images/beCreator/bannerFooter.png'
import BannerFooterRespImg from 'assets/images/beCreator/bannerFooterResponsive.png'



const AreYouReady = () => {

  const { t } = useTranslation()
  const { isMobile, isTab } = useResponsive()

  return (
    <Div
      paddingTop={isMobile ? 120 : 64}
      paddingBottom={isMobile ? 90 : 64}
      borderBottom='1px solid #27272A' // this must be part of Footer
      backgroundColor='black'
    >

      <Card
        width='90%'
        maxWidth={1172}
        height={isTab ? 'unset' : 377}
        margin='0 auto'
        display='flex'
        flexDirection='column'
        position='relative'
        overflow='hidden'
        variant='inverted'
      >
        <Div
          height='fit-content'
          maxWidth={isTab ? 350 : 500}
          marginTop={isTab ? 24 : 'clamp(10px, 8vw ,115px)'}
          marginLeft={isTab ? 'auto' : '8.5%'}
          marginRight='auto'
          marginBottom={isTab ? 46 : 0}
          zIndex={1}
        >
          <Text
            size={isTab ? '2xl' : '4xl'}
            align={isTab ? 'center' : 'left'}
            color='white'
          >
            {t('readyToBecomeCreator')}
          </Text>
          <Div
            display='grid'
            placeItems={isTab ? 'center' : 'start'}
            marginTop={isTab ? 24 : 32}
          >
            <Button
              openNewTab
              to={{ pathname: 'mailto:content@flixxo.com' }}
              size={isMobile ? 'small' : 'large'}
              >
              {t('beCreator')}
            </Button>
          </Div>
        </Div>

        <Div
          as='img'
          src={isMobile ? BannerFooterRespImg : BannerFooterImg}
          alt='asdasd'
          position={isTab ? 'unset' : 'absolute'}
          bottom={0}
          right={isTab ? 0 : '-7%'}
          width={isTab ? '100%' : '72%'}
          minWidth={isTab ? 'unset' : 650}
          marginTop={isTab && !isMobile ? '-10%' : 0}
          transform={isTab && !isMobile ? 'scale(1.1) translateY(-4.5%)' : ''}
        />

      </Card>

      <Faqs />
    </Div>
  )
}

export default AreYouReady